module.exports = __webpack_public_path__ + "dc41f125f89965d3df45e52e1a317da2.png";